export default __webpack_public_path__ + "static/media/nantes4.6dcd5910.jpg";